<template>
  
    <div class="bird-eye-full-wrap">
      <img src="../assets/Images/exhibitor-ariel/expo-lobby-birdeye-view.jpg" class="bird-eye-back-image"  />

      <a
        href="#"
        v-on:click.prevent="getPrvLot"
        v-if="stRange != 0"
        class="exhibitorHallleft"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7.97"
          height="14.5"
          viewBox="0 0 7.97 14.5"
        >
          <path
            id="left-arrow.svg"
            class="cls-1"
            d="M7930.82,2550.05l-5.85,6.17a0.459,0.459,0,0,0-.16.07,0.95,0.95,0,0,0-.29.73,0.936,0.936,0,0,0,.29.73,0.459,0.459,0,0,0,.16.07l5.85,6.17a1,1,0,0,0,1.4,0,0.99,0.99,0,0,0,0-1.39l-5.21-5.58,5.21-5.58a0.972,0.972,0,0,0,0-1.39A1,1,0,0,0,7930.82,2550.05Z"
            transform="translate(-7924.53 -2549.78)"
          />
        </svg>
        {{ $t("expo.prev") }}
      </a>
      <a
        href="#"
        v-on:click.prevent="getNextLot"
        v-if="exhibitorTotalCount > endRange"
        class="exhibitorHallright"
      >
        {{ $t("expo.nxt") }}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="14.56"
          viewBox="0 0 8 14.56"
        >
          <path
            id="right-arrow.svg"
            class="cls-1"
            d="M9297.18,2550.03l5.86,6.18c0.06,0.04.12,0.03,0.17,0.07a0.975,0.975,0,0,1,.28.74,1,1,0,0,1-.28.74,1.041,1.041,0,0,1-.16.06l-5.87,6.19a1.014,1.014,0,0,1-1.41,0,0.99,0.99,0,0,1,0-1.39l5.23-5.6-5.23-5.6a0.972,0.972,0,0,1,0-1.39A1.014,1.014,0,0,1,9297.18,2550.03Z"
            transform="translate(-9295.5 -2549.75)"
          />
        </svg>
      </a>

      <div class="bird-eye-hld">
        <ul class="bird-eye-list">
          <li
            v-bind:id="item.id"
            v-bind:key="item.id"
            v-for="item in Exhibitorlist.slice(stRange, endRange)"
          >
            <a href="#"
            @click.prevent="showtooltip(item)">
              <span><img :src="item.Logo" /></span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  
</template>
<style scope>
.bird-eye-full-wrap {
  width: 100%;
  height: 100%;
  position: relative;
  /* background: url(../assets/Images/exhibitor-ariel/expo-lobby-birdeye-view.jpg)
    no-repeat center center / cover; */
}
.bird-eye-hld {
  width: 65%;
  margin: 0 auto;
  text-align: center;
  padding: 32px 0;
  position:absolute;
  top:32px;
  left:50%;
  transform: translate(-50%);
}
.bird-eye-hld ul {
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
}
.bird-eye-hld ul li {
    list-style: none;
    margin-right: 0px;
    margin-bottom: 30px;
    width: 16.66%;
    padding-right: 50px;
}
/*.bird-eye-hld ul li:nth-child(6n){margin-right:0;}*/
.bird-eye-hld ul li a {
  background: url(../assets/Images/exhibitor-ariel/list-bg.png) no-repeat center
    center / 100%;
  position: relative;
  display: block;
  width: 100%;
  height: 133px;
  align-items: center;
  justify-content: center;
  transform: rotate(-6deg);
  display: inline-block;
}
.bird-eye-hld ul li a span {
    width: 75%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-57%,-69%);
    height: 75%;
    display: flex;
    overflow: hidden;
    justify-content: center;
    align-items: center;
}
.bird-eye-hld ul li a span img {
  max-width: 100%;
  transform: rotate(0deg);
  max-height: 100%;
}

.pl-80 {
  padding-left: 80px;
}

.expoarielview-wrap {
  position: relative;
}

.ariel-booths {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: absolute;
  top: 169px;
  left: 0;
  width: 100%;
}

.ariel-booths ul {
  margin: 0 10px;
  padding: 0;
}

.ariel-booths li {
  display: block;
  list-style: none;
}

.ariel-single-booth {
  height: 94px;
  width: 177px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
}

.ariel-booths ul:first-child {
  transform: skew(-20deg);
}

.ariel-booths ul:nth-child(2) {
  transform: skew(-13deg);
}

.ariel-booths ul:nth-child(3) {
  margin-left: 50px;
  transform: skew(-7deg);
}

.ariel-booths ul:nth-child(3) li {
  transform: skew(7deg);
}

.ariel-booths ul:nth-child(4) {
  margin-right: 48px;
  transform: skew(7deg);
  margin-left: 56px;
}

.ariel-booths ul:nth-child(4) li {
  transform: skew(-7deg);
}

.ariel-booths ul:first-child li {
  transform: skew(20deg);
}

.ariel-booths ul:nth-child(2) li {
  transform: skew(13deg);
}

.ariel-booths ul:nth-child(5) {
  transform: skew(20deg);
}

.ariel-booths ul:nth-child(5) li {
  transform: skew(-20deg);
}

.ariel-booths ul:last-child {
  transform: skew(20deg) !important;
}

.ariel-booths ul:last-child li {
  transform: skew(-20deg) !important;
}

.arial-exhibitor-logo {
  position: absolute;
  height: 66%;
  width: 88%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 5px;
}

.arial-exhibitor-logo2 {
  position: absolute;
  height: 66%;
  width: 88%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 5px;
}

.arial-exhibitor-logo3 {
  position: absolute;
  height: 66%;
  width: 88%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 5px;
}

.arial-exhibitor-logo4 {
  position: absolute;
  height: 66%;
  width: 88%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 5px;
}

.arial-exhibitor-logo2.arial-exhibitor-logo5 {
  position: absolute;
  height: 66%;
  width: 88%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 5px;
}

.arial-exhibitor-logo.arial-exhibitor-logo5 {
  position: absolute;
  height: 66%;
  width: 88%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 5px;
}

.ariel-single-booth div img {
  max-height: 100%;
}

.single-booth {
  position: relative;
}

.booth-hidden {
  visibility: hidden;
}

.ariel-booths ul:first-child {
  margin-right: 54px;
}

.ariel-booths.test ul li a .arial-exhibitor-logo:hover {
  cursor: url("../assets/Images/custome-cursor.png"), auto;
}

.ariel-booths.test ul li a .arial-exhibitor-logo2:hover {
  cursor: url("../assets/Images/custome-cursor.png"), auto;
}

.ariel-booths.test ul li a .arial-exhibitor-logo3:hover {
  cursor: url("../assets/Images/custome-cursor.png"), auto;
}
.ariel-booths.test ul li a .arial-exhibitor-logo4:hover {
  cursor: url("../assets/Images/custome-cursor.png"), auto;
}

.ariel-booths.test ul li a .arial-exhibitor-logo.arial-exhibitor-logo5:hover {
  cursor: url("../assets/Images/custome-cursor.png"), auto;
}

.custom-tool-tip-right .head-left h3 {
  font-size: 18px !important;
  font-weight: 600;
  color: #333;
  margin: 0;
  cursor: pointer;
}

.custom-tool-tip-right .tool-tip-desc-info-box p {
  font-size: 14px !important;
  font-weight: 400;
  color: #333;
  line-height: 18px;
  margin: 0 0 20px;
}

.tool-tip-desc-info-box ul li a {
  display: inline-block;
  font-size: 16px;
  font-weight: 400;
  color: #333;
  margin-right: 20px;
}

@media only screen and (min-width: 1450px) and (max-width: 1600px) {
.bird-eye-hld {
    width: 73%;
}
.bird-eye-hld ul {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}
.bird-eye-hld ul li {
    margin-right: 0;
    margin-bottom: 0;
    width: 14.66%;
    padding-right: 30px;
}

.bird-eye-hld ul li a {
    width: 100%;
}
}

@media only screen and (min-width: 1367px) and (max-width: 1440px) {
.bird-eye-hld {
    width: 73%;
}
.bird-eye-hld ul {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}
.bird-eye-hld ul li {
    margin-right: 0;
    margin-bottom: -21px;
    width: 13.66%;
    padding-right: 30px;
}
.bird-eye-hld ul li a {
    width: 100%;
}
.bird-eye-hld {
    padding: 0px 0 0;
    top: 0;
}
}

@media only screen and (max-width: 1366px) {
.bird-eye-hld {
    width: 68%;
    padding: 10px 0;
}
.bird-eye-hld ul {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}
.bird-eye-hld ul li {
    margin-right: 0;
    margin-bottom: -10px;
    width: 16.66%;
    padding-right: 24px;
}
.bird-eye-hld ul li a {
    width: 100%;
    display: inherit;
}
}
@media screen and (max-width: 767px) {
.bird-eye-back-image{display: none;}
.bird-eye-full-wrap {min-height: 100vh; background: #333;} 
.bird-eye-hld {width: 100%; padding: 10px 0; position: relative; top: 0; left: 0; transform: none;}
.bird-eye-hld ul li {margin-right: 0; margin-bottom: 0; width: 50%; padding-right: 0;}
.bird-eye-hld ul li a {transform: rotate(0deg); margin-bottom: 10px;}
}
</style>

<script>
import jQuery from "jquery";
import db from "../components/firebaseInit";
import router from "../router";
import store from "../store";
let $ = jQuery;
var self;
export default {
  data() {
    return {
      Exhibitorlist: [],
      exhibitorTotalCount: 0,
      stRange: 0,
      endRange: 36,
      indexRow1: [30, 24, 18, 12, 6, 0],
      indexRow2: [31, 25, 19, 13, 7, 1],
      indexRow3: [32, 26, 20, 14, 8, 2],
      indexRow4: [33, 27, 21, 15, 9, 3],
      indexRow5: [34, 28, 22, 16, 10, 4],
      indexRow6: [35, 29, 23, 17, 11, 5],
      firstBoothDetails: [],
      secondBoothDetails: [],
      thirdBoothDetails: [],
      fourthBoothDetails: [],
      fifthBoothDetails: [],
      sixthBoothDetails: [],
      toolTipDetails: [],
      mouseCursorFlg: false,
      maxBoothIncrease: false,
      increaseVal: 0,
    };
  },
  methods: {
    loadView(id) {
      store.commit("addExhibitorID", id);
      router.push({ name: "ExhibitorsView" });
    },
    closetooltip: function (val) {
      $("#" + val).hide();
    },
    getExhibitorList() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var docref = db
        .collection(obj.eventcollectionname)
        .doc("ExhibitorList")
        .collection("Exhibitors")
        .orderBy("DisplaySequence", "asc")
        .where("IsPublished", "==", true);
      docref
        .get()
        .then((querySnapshot) => {
          debugger;
          self.exhibitorTotalCount = querySnapshot.size;
          //alert(self.exhibitorTotalCount);
          self.stRange = 0;
          if (self.exhibitorTotalCount < 36) {
            self.endRange = self.exhibitorTotalCount;
          } else {
            self.endRange = 36;
          }
          // if(self.exhibitorTotalCount > 36 && self.exhibitorTotalCount < 72){

          //   self.increaseVal = 36;
          // }else if(self.exhibitorTotalCount > 72 && self.exhibitorTotalCount < 108){
          //   self.increaseVal = 72;
          // }
          var id = "";
          querySnapshot.forEach((doc) => {
            id += doc.id + ",";
            store.commit("addExbList", id.substring(0, id.length - 1));
            self.Exhibitorlist.push(doc.data());
          });
          //this.buildingBooth(this.Exhibitorlist);
        })
        .catch((error) => {
          alert(error);
        });
    },
    buildingBooth(data) {
      this.indexRow1.map((row1) => {
        if (data[row1]) {
          this.firstBoothDetails.push(data[row1]);
        } else {
          this.firstBoothDetails.push({});
        }
      });

      this.indexRow2.map((row2) => {
        if (data[row2]) {
          this.secondBoothDetails.push(data[row2]);
        } else {
          this.secondBoothDetails.push({});
        }
      });

      this.indexRow3.map((row3) => {
        if (data[row3]) {
          this.thirdBoothDetails.push(data[row3]);
        } else {
          this.thirdBoothDetails.push({});
        }
      });

      this.indexRow4.map((row4) => {
        if (data[row4]) {
          this.fourthBoothDetails.push(data[row4]);
        } else {
          this.fourthBoothDetails.push({});
        }
      });

      this.indexRow5.map((row5) => {
        if (data[row5]) {
          this.fifthBoothDetails.push(data[row5]);
        } else {
          this.fifthBoothDetails.push({});
        }
      });

      this.indexRow6.map((row6) => {
        if (data[row6]) {
          this.sixthBoothDetails.push(data[row6]);
        } else {
          this.sixthBoothDetails.push({});
        }
      });
    },
    showtooltip: function (data) {
      store.commit("addExhibitorID", data.ExhibitorId);
      router.push({ name: "ExhibitorsView" });
    },
    getPrvLot: function () {
      this.stRange = parseInt(this.stRange) - 36;
      if (this.stRange <= 0) {
        this.stRange = 0;
      }

      this.endRange = parseInt(this.endRange) - 36;
      if (this.endRange >= this.exhibitorTotalCount) {
        this.endRange = this.exhibitorTotalCount;
      }
      if (this.endRange % 36 !== 0) {
        this.endRange = parseInt(this.endRange) + (36 - (this.endRange % 36));
      }

      this.indexRow1 = [30, 24, 18, 12, 6, 0];
      this.indexRow2 = [31, 25, 19, 13, 7, 1];
      this.indexRow3 = [32, 26, 20, 14, 8, 2];
      this.indexRow4 = [33, 27, 21, 15, 9, 3];
      this.indexRow5 = [34, 28, 22, 16, 10, 4];
      this.indexRow6 = [35, 29, 23, 17, 11, 5];

      this.firstBoothDetails = [];
      this.secondBoothDetails = [];
      this.thirdBoothDetails = [];
      this.fourthBoothDetails = [];
      this.fifthBoothDetails = [];
      this.sixthBoothDetails = [];
      this.buildingBooth(this.Exhibitorlist);
    },
    getNextLot: function () {
      this.stRange = parseInt(this.stRange) + 36;

      this.endRange = parseInt(this.endRange) + 36;
      if (this.endRange > this.exhibitorTotalCount) {
        this.endRange = this.exhibitorTotalCount;
      }

      this.indexRow1 = [
        30 + this.increaseVal,
        24 + this.increaseVal,
        18 + this.increaseVal,
        12 + this.increaseVal,
        6 + this.increaseVal,
        0 + this.increaseVal,
      ];
      this.indexRow2 = [
        31 + this.increaseVal,
        25 + this.increaseVal,
        19 + this.increaseVal,
        13 + this.increaseVal,
        7 + this.increaseVal,
        1 + this.increaseVal,
      ];
      this.indexRow3 = [
        32 + this.increaseVal,
        26 + this.increaseVal,
        20 + this.increaseVal,
        14 + this.increaseVal,
        8 + this.increaseVal,
        2 + this.increaseVal,
      ];
      this.indexRow4 = [
        33 + this.increaseVal,
        27 + this.increaseVal,
        21 + this.increaseVal,
        15 + this.increaseVal,
        9 + this.increaseVal,
        3 + this.increaseVal,
      ];
      this.indexRow5 = [
        34 + this.increaseVal,
        28 + this.increaseVal,
        22 + this.increaseVal,
        16 + this.increaseVal,
        10 + this.increaseVal,
        4 + this.increaseVal,
      ];
      this.indexRow6 = [
        35 + this.increaseVal,
        29 + this.increaseVal,
        23 + this.increaseVal,
        17 + this.increaseVal,
        11 + this.increaseVal,
        5 + this.increaseVal,
      ];

      this.firstBoothDetails = [];
      this.secondBoothDetails = [];
      this.thirdBoothDetails = [];
      this.fourthBoothDetails = [];
      this.fifthBoothDetails = [];
      this.sixthBoothDetails = [];
      this.buildingBooth(this.Exhibitorlist);
    },
  },
  mounted() {
    self = this;
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    if (obj.IsMouseCursorEnabled == true) {
      this.mouseCursorFlg = true;
    } else {
      this.mouseCursorFlg = false;
    }
    $("#btnAddUserView").click();
    $("#imgBanner").attr("src", obj.EventBranding[0].banner);
    $("#topmenu").show();
    self.getExhibitorList();
  },
};
</script>

<style scoped>
@import "../assets/expo.css";
@import "../assets/Hotspot/css/jquery-ui-1.9.2.custom.min.css";
</style>